import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Button, Card, Modal } from 'antd';
import CreditCard from '../Common/PaymentProcessing/CreditCard/CreditCard';
import Check from '../Common/PaymentProcessing/Check/Check';
import PurchaseOrder from '../Common/PaymentProcessing/PurchaseOrder/PurchaseOrder';
import WireTransfer from '../Common/PaymentProcessing/WireTransfer/WireTransfer';
import { ReactComponent as PaymentsIcon } from '../../assets/icons/payments.svg';
import { ReactComponent as ItemIcon } from '../../assets/icons/item.svg';
import { useHistory } from 'react-router-dom';

import { connect, useSelector } from 'react-redux';

import PaymentGateway from './PaymentProcessing/PaymentGateway/PaymentGateway';
const PayNow = props => {
	const [paymentApproved, setPaymentApproved] = useState(false);
	const [paymentDisplayDOM, setPaymentDisplayDOM] = useState('');
	const { moduleUrlId } = useParams();
	const history = useHistory();
	const [showPGModal, setShowPGModal] = useState(false);
	const publicEmbed =
		useSelector(state => state.settings.publicEmbed) ||
		window.location.search.includes('public_embed=1'); // on the refresh the redux doesn't set public_embed, need windows.location.search for safety

	const appdir = useSelector(state => state.loginInfo.appdir);
	const ssotoken = useSelector(state => state.auth.ssotoken);
	const contactUuid = useSelector(state => state.auth.contact_uuid);
	const commonStatus = useSelector(state => state.common.status);
	const paymentSuccess = useSelector(state => state.common.paymentSuccess);
	const paymentErrorMsg = useSelector(state => state.common.paymentErrorMsg);
	const onPaymentSubmit = success => {
		if (props.returnPaymentApproved) {
			props.returnPaymentApproved(success);
		}
		setPaymentApproved(success);
	};

	const onDownloadInvoice = () => {
		if (props.moduleIdentifier === 'ecommerce' || props.moduleIdentifier === 'registration') {
			window.open(
				`https://masterapp.econference.io/masterapp_summer2012/apiv2/index.cfm?appdir=${appdir}&module=attendee&component=attendees&function=download_invoice&moduleurlid=${moduleUrlId}&attenuuid=${
					props.attenuuid ? props.attenuuid : props.ecommerce.oldAttenuuid
				}`,
			);
		} else if (props.moduleIdentifier === 'exhibitor') {
			window.open(
				`https://masterapp.econference.io/masterapp_summer2012/apiv2/index.cfm?appdir=${appdir}&module=exhibitor&component=exhibitors&function=download_invoice&moduleurlid=${moduleUrlId}&compuuid=${props.compuuid}&exhibuuid=${props.exhibuuid}`,
			);
		}
	};

	const clickBackCorporateMembership = () => {
		history.push(`./staff`);
	};

	const ssoLoginToFullApp = () => {
		window.open(
			`https://${appdir}.xcdapp.io/main/company/${moduleUrlId}/staff?token=${ssotoken}&uuid=${contactUuid}`,
		);
	};

	useEffect(() => {
		if (props.common.paymentSuccess) {
			if (props.common.paymentSuccess === true) {
				setPaymentApproved(true);
				if (props.returnPaymentApproved) {
					props.returnPaymentApproved(true);
				}
				// Reset payment method on success
				if (props.setCurrentPaymentMethod) {
					props.setCurrentPaymentMethod('');
				}
			} else if (props.common.paymentSuccess === false) {
				// Payment failed - close modal but keep PayNow rendered to show error
				setShowPGModal(false);
				setPaymentDisplayDOM('');
				// Don't reset currentPaymentMethod here - keep it so PayNow stays rendered
			}
		}
	}, [props.common.paymentSuccess]);

	useEffect(() => {
		if (props.currentPaymentMethod && parseInt(props.cartItems?.NetOwing) > 0) {
			renderPaymentComponent();
		} else if (!props.currentPaymentMethod) {
			// Reset payment display when payment method is cleared
			setPaymentDisplayDOM('');
			setShowPGModal(false);
		}
	}, [props.currentPaymentMethod]);

	useEffect(() => {
		// When payment error occurs, close modal and reset currentPaymentMethod
		// Error is shown in FreeCheckout, so PayNow doesn't need to stay rendered
		if (paymentErrorMsg) {
			setShowPGModal(false);
			setPaymentDisplayDOM('');
			// Reset currentPaymentMethod so Credit Card button can be clicked again
			if (props.setCurrentPaymentMethod) {
				props.setCurrentPaymentMethod('');
			}
		}
	}, [paymentErrorMsg]);

	useEffect(() => {
		// When payment fails but no error message, close modal but keep PayNow rendered
		if (props.common.paymentSuccess === false && !paymentErrorMsg) {
			setShowPGModal(false);
			setPaymentDisplayDOM('');
			// Don't reset currentPaymentMethod here - keep it so PayNow stays rendered to show error
		}
	}, [props.common.paymentSuccess, paymentErrorMsg]);

	const paymentComplete = () => {
		// Force modal to close immediately
		setShowPGModal(false);
		setPaymentDisplayDOM('');
		// Reset payment method to allow Credit Card button to work again
		// But only if there's no error message (error is shown in FreeCheckout)
		if (props.setCurrentPaymentMethod && !paymentErrorMsg) {
			props.setCurrentPaymentMethod('');
		}
	};
	const renderPaymentComponent = () => {
		switch (props.currentPaymentMethod) {
			case 'creditcard':
				setPaymentDisplayDOM(
					<CreditCard
						settings={props.paymentSettings.creditcardsettings}
						paymentSubmitted={onPaymentSubmit}
						netOwing={props.netOwing}
						attenuuid={props.attenuuid}
						moduleIdentifier={props.moduleIdentifier}
						compuuid={props.compuuid}
						exhibuuid={props.exhibuuid}
						publicEmbed={props.publicEmbed}
					/>,
				);
				break;
			case 'react_hosted':
				setPaymentDisplayDOM(
					<PaymentGateway
						settings={props.paymentSettings.reacthostedsettings}
						paymentSubmitted={onPaymentSubmit}
						netOwing={props.netOwing}
						attenuuid={props.attenuuid}
						moduleIdentifier={props.moduleIdentifier}
						compuuid={props.compuuid}
						exhibuuid={props.exhibuuid}
						publicEmbed={props.publicEmbed}
						onPaymentCompletion={paymentComplete}
					/>,
				);
				setShowPGModal(true);
				break;
			case 'check':
				setPaymentDisplayDOM(
					<Check
						netOwing={props.netOwing}
						paymentSubmitted={onPaymentSubmit}
						attenuuid={props.attenuuid}
						moduleIdentifier={props.moduleIdentifier}
						compuuid={props.compuuid}
						exhibuuid={props.exhibuuid}
						publicEmbed={props.publicEmbed}
					/>,
				);
				break;
			case 'purchaseorder':
				setPaymentDisplayDOM(
					<PurchaseOrder
						paymentSubmitted={onPaymentSubmit}
						netOwing={props.netOwing}
						attenuuid={props.attenuuid}
						moduleIdentifier={props.moduleIdentifier}
						compuuid={props.compuuid}
						exhibuuid={props.exhibuuid}
						publicEmbed={props.publicEmbed}
					/>,
				);
				break;
			case 'wiretransfer':
				setPaymentDisplayDOM(
					<WireTransfer
						paymentSubmitted={onPaymentSubmit}
						netOwing={props.netOwing}
						attenuuid={props.attenuuid}
						moduleIdentifier={props.moduleIdentifier}
						compuuid={props.compuuid}
						exhibuuid={props.exhibuuid}
						publicEmbed={props.publicEmbed}
					/>,
				);
				break;
			default:
				return;
		}
	};
	const handlePGCancelOperation = () => {
		setPaymentDisplayDOM('');
		setShowPGModal(false);
		if (props.setCurrentPaymentMethod) {
			props.setCurrentPaymentMethod('');
		}
	};
	return (
		<div>
			{
				// (props.status === 'Complete' ||
				// 	props.status === 'Pending' ||
				// 	commonStatus === 'Complete' ||
				// 	commonStatus === 'Pending')
				Boolean(paymentSuccess) && (
					<div>
						{(paymentApproved || parseFloat(props.netOwing) == 0) && (
							<Card className="card">
								<ItemIcon
									className="fg-primary-dark-light"
									style={{
										float: 'right',
										width: 'min(100%, 4em)',
									}}
								/>

								<div
									dangerouslySetInnerHTML={{
										__html: props.paymentSettings.approvedpaymentscreentext,
									}}
								></div>

								{props.moduleIdentifier === 'exhibitor' ? (
									<div style={{ display: 'flex' }}>
										<Button
											className="login-form-button gx-mt-1 button-primary"
											shape={'round'}
											onClick={onDownloadInvoice}
										>
											Download Invoice
										</Button>
										<Button
											className="login-form-button gx-mt-1 button-primary"
											shape={'round'}
											onClick={
												publicEmbed
													? ssoLoginToFullApp
													: clickBackCorporateMembership
											}
										>
											Manage Staff
										</Button>
									</div>
								) : (
									<Button
										className="login-form-button gx-mt-1 button-primary"
										shape={'round'}
										onClick={onDownloadInvoice}
									>
										Download Invoice
									</Button>
								)}
							</Card>
						)}
					</div>
				)
			}
			{parseFloat(props.netOwing) > 0 &&
				paymentDisplayDOM &&
				(showPGModal ? (
					<Modal
						visible={showPGModal}
						title="Make Payment"
						footer={[]}
						closable={true}
						onCancel={handlePGCancelOperation}
						style={{ top: '10px' }}
						width="70%"
					>
						{paymentDisplayDOM}
					</Modal>
				) : (
					<div>{paymentDisplayDOM}</div>
				))}
		</div>
	);
};

const mapStateToProps = state => {
	return {
		common: state.common,
		ecommerce: state.ecommerce,
	};
};

export default connect(mapStateToProps)(PayNow);
